<template>
    <div class="card card-pdv">
        <PageHeader :title="i18nPunctualVision" />
        <div class="card-body">
            <stacked-column-full-chart
                :series-prop="series"
                :categories-series-prop="categories"
                :busy="loading"
                :colors-prop="['#64BB77', '#32BDF9', '#EDB012', '#ED6112', '#AF0404']"
            />
        </div>
    </div>
</template>

<script>
import UserPerformanceService from '@src/services/dashboards/UserPerformanceService.js'

import PageHeader from '@/src/components/PageHeader.vue'
import StackedColumnFullChart from '@/src/components/charts/StackedColumnFullChart.vue'
import swalFeedback from '@src/mixins/swalFeedback.vue'
import validationMixin from '@src/mixins/validation.vue'

const i18nKey = 'DASHBOARDS'
const i18nCommon = 'COMMON'

export default {
    components: {
        PageHeader,
        StackedColumnFullChart,
    },
    mixins: [
        validationMixin,
        swalFeedback,
    ],
    data() {
        return {
            i18nKey,
            i18nCommon,
            additionalParameters: {},
            loading: false,
            series: [],
            categories: [],
        }
    },
    validations: {},
    computed: {
        i18nPunctualVision() {
            return this.getI18n(i18nKey, 'TITLES.punctual_vision')
        },
        i18nPunctuality() {
            return this.getI18n(i18nCommon, 'punctuality')
        },
        i18nWorkSchedule() {
            return this.getI18n('WORKSCHEDULES', 'TITLES.work_schedule')
        },
        i18nQuestionnaire() {
            return this.getI18n('QUESTIONNAIRES', 'TITLES.questionnaire')
        },
        i18nTimeInStore() {
            return this.getI18n('POS_CHECK', 'FIELDS.time_in_store')
        },
        i18nCheckInDistance() {
            return this.getI18n(i18nCommon, 'checkin_distance')
        },
        i18nCheckOutDistance() {
            return this.getI18n(i18nCommon, 'checkout_distance')
        },
        i18nBattery() {
            return this.getI18n('POS_CHECK', 'FIELDS.battery')
        },
    },
    methods: {
        getPillarLabel(pillarKey) {
            const labels = {
                punctuality: this.i18nPunctuality,
                work_schedule: this.i18nWorkSchedule,
                task: this.i18nQuestionnaire,
                checkin_distance: this.i18nCheckInDistance,
                checkout_distance: this.i18nCheckOutDistance,
                time_in_store: this.i18nTimeInStore,
                battery: this.i18nBattery,
            }
            return labels[pillarKey] || pillarKey
        },
        refresh(parameters) {
            this.loading = true
            this.series = []
            this.categories = []
            this.additionalParameters = parameters

            const pillarOrder = ['punctuality', 'work_schedule', 'task', 'checkin_distance', 'checkout_distance', 'time_in_store', 'battery']

            UserPerformanceService.statics(this.additionalParameters)
                .then((response) => {
                    const data = response.data.data || {}
                    const activeKeys = pillarOrder.filter((key) => Object.prototype.hasOwnProperty.call(data, key))

                    this.categories = activeKeys.map((key) => this.getPillarLabel(key))

                    this.series = [
                        { name: '90%-100%', data: activeKeys.map((key) => data[key].A) },
                        { name: '60%-89%', data: activeKeys.map((key) => data[key].B) },
                        { name: '40%-59%', data: activeKeys.map((key) => data[key].C) },
                        { name: '1%-39%', data: activeKeys.map((key) => data[key].D) },
                        { name: '0%', data: activeKeys.map((key) => data[key].E) },
                    ]

                    this.loading = false
                })
                .catch((err) => {
                    this.loading = false
                    return err
                })
        },
    },
}
</script>
